import { TApiPagRes } from "@/types/api";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useInfiniteScroll = <T extends object>(queryKey: unknown[], fetchFn: (page: number) => Promise<TApiPagRes<T>>, options?: object) => {
  const query = useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) => fetchFn(pageParam as number),
    initialPageParam: 1,
    getNextPageParam: ({ pagination: { page, totalPage } }) => {
      if (page < totalPage) return page + 1;
      return undefined;
    },
    ...options,
  });

  const dataFormatter = useMemo(() => query.data?.pages.flatMap(({ data }) => data) ?? [], [query.data]);

  // Total item count reported by the API (independent of how many pages are currently in cache).
  const total = query.data?.pages[0]?.pagination?.total ?? 0;

  return {
    ...query,
    dataFormatter,
    total,
    fetchNextPage: async () => {
      await query.fetchNextPage();
    },
  };
};
